export enum ScreenBreakpointPX {
  XXL = 1536,
  XL = 1280,
  LG = 1024,
  MD = 768,
  SM = 640,
  XS = 1
}
export enum ScreenBreakpointBW {
  XXL = 1 << 4,
  XL = 1 << 3,
  LG = 1 << 2,
  MD = 1 << 1,
  SM = 1 << 0,
  XS = 0
}

export const ScreenBreakpointMapping: Record<ScreenBreakpointPX, ScreenBreakpointBW> = {
  [ScreenBreakpointPX.XS]: ScreenBreakpointBW.XS,
  [ScreenBreakpointPX.SM]: ScreenBreakpointBW.SM,
  [ScreenBreakpointPX.MD]: ScreenBreakpointBW.MD,
  [ScreenBreakpointPX.LG]: ScreenBreakpointBW.LG,
  [ScreenBreakpointPX.XL]: ScreenBreakpointBW.XL,
  [ScreenBreakpointPX.XXL]: ScreenBreakpointBW.XXL
};
